import {
  Spinner,
  MessageBar,
  MessageBarType,
  Dialog,
  DialogFooter,
  DialogType,
  DefaultButton,
  PrimaryButton,
} from '@fluentui/react';
import {useState} from 'react';
import commonStyles from '../../common/commonStyles.module.scss';
import {ProductSetting} from '../../Swagger/api';
import {getApis} from '../../webservices';

interface IProductSettingRemove {
  onDone: () => void;
  onCancel: () => void;
  productSetting: ProductSetting;
}

export const ProductSettingRemove = (props: IProductSettingRemove) => {
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const onDelete = async () => {
    setLoading(true);
    setHasError(false);

    try {
      const {productSettingClient} = await getApis();
      await productSettingClient.removeProductSetting(
        props.productSetting.productId,
        props.productSetting.clientId
      );
      props.onDone();
    } catch {
      setHasError(true);
      setLoading(false);
    }
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        subText:
          'Deleting the product setting will delete the product settings. The data can not be recovered. Are you sure?',
        title: 'Delete product setting',
        type: DialogType.normal,
      }}
      modalProps={{
        isBlocking: true,
      }}
      minWidth="40em"
      onDismiss={props.onCancel}
    >
      <DialogFooter>
        <section className={commonStyles.dialogMessages}>
          {loading ? (
            <Spinner
              className={commonStyles.spinner}
              label="Please wait"
              ariaLive="assertive"
              labelPosition="right"
            />
          ) : null}
          {hasError ? (
            <MessageBar
              className={commonStyles.messageBar}
              messageBarType={MessageBarType.error}
              isMultiline={true}
              dismissButtonAriaLabel="Close"
            >
              Something went wrong. Please try again or contact an
              Administrator.
            </MessageBar>
          ) : null}
        </section>
        <PrimaryButton onClick={onDelete} text="Delete" />
        <DefaultButton onClick={props.onCancel} text="Cancel" />
      </DialogFooter>
    </Dialog>
  );
};
